import { Pipe, PipeTransform } from '@angular/core';

export interface FieldHintRule {
  show: boolean;
  text: string;
}

/**
 * Picks the first matching hint text (priority order).
 * Used to collapse former &lt;b3-message&gt; siblings into DS input [hint].
 */
@Pipe({
  name: 'fieldHint',
  standalone: false,
})
export class FieldHintPipe implements PipeTransform {
  transform(rules: FieldHintRule[] | null | undefined): string {
    if (!rules?.length) {
      return '';
    }
    const match = rules.find(rule => rule?.show && !!rule.text);
    return match?.text ?? '';
  }
}
